import { AppStoreButton } from "../AppStoreButton/AppStoreButton";
import { PilotButton } from "../PilotButton/PilotButton";
import { useTranslation } from "react-i18next";

export function Hero() {
    const { t } = useTranslation();
    return (
        <div
            id="top"
            className="flex flex-col gap-12 justify-center items-center w-full text-pine mt-36 pt-12 px-12 lg:px-24 lg:pt-24 xl:pt-64"
        >
            <div className="font-oswald leading-none uppercase font-bold text-center text-[7rem] md:text-[8rem] xl:text-[10rem]">
                {t("gf-hero-title-1")}
            </div>
            <div className="flex flex-col gap-12 items-center text-center max-w-screen-lg">
                <div className="font-robotoCondensed text-[3rem] md:text-[3rem] xl:text-[4rem] leading-none font-bold">
                    {t("gf-hero-title-2")}
                </div>
                <div className="text-lg text-left">{t("gf-hero-subtitle")}</div>
                <div className="flex gap-12 pt-4 lg:pt-12">
                    <AppStoreButton />
                    <PilotButton />
                </div>
            </div>
        </div>
    );
}
